import "./styles.css";

export default function Header() {
  return (
    <div className="Header">
      <h1>Dictionary</h1>
    </div>
  );
}
